import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { salesInvoiceRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE, IRoleEnum.STORE_EMPLOYEE];

const salesInvoiceRouteMetadata: IRouteMetadataObj<
  typeof salesInvoiceRoutesObj
> = {
  list: {
    title: "salesManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/salesManagement/salesInvoice/table/page"),
    mode: "index",
    type: "main",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "salesManagement.salesInvoice.view.title",
    description: "empty",
    lazy: () => import("@/pages/salesManagement/salesInvoice/view/page"),
    mode: "view",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
    pageState: { actionType: "back", noPadding: true },
  },
  debtPayment: {
    title: "salesManagement.salesInvoice.debtPayment.title",
    description: "empty",
    lazy: () =>
      import("@/pages/salesManagement/salesInvoice/debtPayment/view/page"),
    mode: "view",
    type: "inner",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  viewPayment: {
    title: "salesManagement.salesInvoice.viewPayment.title",
    description: "empty",
    lazy: () =>
      import("@/pages/salesManagement/salesInvoice/viewPayments/table/page"),
    mode: "view",
    type: "inner",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  returnGoods: {
    title: "salesManagement.salesInvoice.returnOfGoods.title",
    description: "empty",
    lazy: () => import("@pages/salesManagement/returnGoods/page"),
    mode: "create",
    type: "inner",
    icon: "CalendarCheckLine",
    breadcrumbs: [],
    permission,
    pageState: { noPadding: true, actionType: "back" },
  },
};

export const salesInvoiceRoutes = createRoute<typeof salesInvoiceRoutesObj>(
  salesInvoiceRoutesObj,
  salesInvoiceRouteMetadata,
);
